import { ViewportType } from '../types';

/**
 * Sparky's own `platformMap` only knows mobile and desktop, so the tablet
 * bucket is derived from the two breakpoints that bracket it: `md` is 768px
 * and `lg` is 1024px (see libs/sparky/src/sparky.config.ts).
 */
export const getViewportType = ({ md, lg }: { md: boolean; lg: boolean }): ViewportType => {
  if (lg) return 'desktop';
  if (md) return 'tablet';
  return 'mobile';
};
